import { render, staticRenderFns } from "./joining.vue?vue&type=template&id=74c2a37f&"
import script from "./joining.vue?vue&type=script&lang=js&"
export * from "./joining.vue?vue&type=script&lang=js&"
import style0 from "./joining.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports